module.exports = __webpack_public_path__ + "static/media/6-8.72fea9ee.mp3";